import { intlFormatCurrency } from '@iwIntlProvider/FormattedCurrency';
import {
    IconCreditCardFilled,
    IconArrowDownWideNarrow,
    IconRocket,
    IconUserFilled
} from '@iwoca/icons';
import { FormattedDate, FormattedMessage, useIntl } from 'react-intl';

import styles from './xsellTitle.module.css';
import { useIsInDERepaymentReductionTest } from '../../../../../customHooks/useIsInDERepaymentReductionTest';
import IwMedia from '../../../../../iwMedia/IwMedia';
import Fetching from '../../../../ui/fetching/fetching';

export const XSellTitle = ({
    expiryDate,
    maxCashAmount
}: {
    expiryDate?: string;
    maxCashAmount: number;
}) => {
    const intl = useIntl();
    const isInRepaymentReductionSplitTest = useIsInDERepaymentReductionTest();

    return (
        <div className={styles.header}>
            <h1 className={styles.title}>
                <FormattedMessage
                    id="_.xsell.xsell_title.title"
                    defaultMessage="You’ve been approved for {amount}"
                    values={{
                        amount: (
                            <span className={styles.amount}>
                                {intlFormatCurrency({
                                    intl,
                                    value: maxCashAmount || 0
                                })}
                            </span>
                        )
                    }}
                />
            </h1>
            <h2 className={styles.subTitle}>
                <FormattedMessage
                    id="_.xsell.xsell_title.expiry_date"
                    defaultMessage="Valid until {date}"
                    values={{
                        date: (
                            <Fetching isFetching={!expiryDate}>
                                <FormattedDate
                                    value={
                                        expiryDate
                                            ? new Date(expiryDate)
                                            : new Date()
                                    }
                                    day="2-digit"
                                    month="long"
                                    year="numeric"
                                />
                            </Fetching>
                        )
                    }}
                />
            </h2>
            <h2 className={styles.subTitle}>
                <FormattedMessage
                    id="_.xsell.xsell_title.sub_title"
                    defaultMessage="Select an offer below to continue."
                />
            </h2>
            <IwMedia from="medium">
                <ul className={styles.benefitPoints}>
                    <li>
                        <IconUserFilled />
                        <FormattedMessage
                            id="_.xsell.xsell_title.subheader_one"
                            defaultMessage="Get your own account manager"
                        />
                    </li>
                    <li>
                        <IconRocket />
                        <FormattedMessage
                            id="_.xsell.xsell_title.subheader_two"
                            defaultMessage="Top up your loan in a few clicks"
                        />
                    </li>
                    {isInRepaymentReductionSplitTest && (
                        <li>
                            <IconArrowDownWideNarrow />
                            <FormattedMessage
                                id="_.xsell.xsell_title.subheader_repayment_reduction"
                                defaultMessage="Repayment reduction upon request"
                            />
                        </li>
                    )}
                    <li>
                        <IconCreditCardFilled />
                        <FormattedMessage
                            id="_.xsell.xsell_title.subheader_three"
                            defaultMessage="No early repayment fees"
                        />
                    </li>
                </ul>
            </IwMedia>
        </div>
    );
};
